export default __webpack_public_path__ + "static/media/model1.a6268707.png";